import "./walletspage.scss";
import React, { useEffect, useState } from "react";
import { Wallet, Wallet2Icon, Plus } from "lucide-react";
import { formatAssetAmount } from "../../../utils/decimal";
import { useAppSelector } from "../../../features/helpers";
import { UserInfo } from "../../../store/UserSlice";
import { WalletService } from "../../../services/WalletService";
import { InvoiceService } from "../../../services/WithdrawalService";
import ModalAddWallet from "../../../components/modal/modal-add-wallet/modal-add-wallet";
import { SelectMenu } from "../../../components/ui";

const WalletsPage: React.FC = () => {

    const userInfo: UserInfo = useAppSelector((state) => state.user.userInfo);

    // Carteiras de destino (hard-wallets) + saques do cliente.
    const [hardWallets, setHardWallets]     = useState<any[]>([]);
    const [userInvoices, setUserInvoices]   = useState<any[]>([]);
    const [selectedHwId, setSelectedHwId]   = useState<string>("");
    const [addWalletOpen, setAddWalletOpen] = useState<boolean>(false);

    const loadHardWallets = () => {
        if (!userInfo?.id) return;
        WalletService.getHwByUserId(userInfo.id)
            .then((r: any) => setHardWallets(Array.isArray(r) ? r : []))
            .catch(() => setHardWallets([]));
    };
    const loadUserInvoices = () => {
        if (!userInfo?.id) return;
        InvoiceService.getByUser(userInfo.id)
            .then((r: any) => setUserInvoices(Array.isArray(r) ? r : []))
            .catch(() => setUserInvoices([]));
    };
    useEffect(() => {
        loadHardWallets();
        loadUserInvoices();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userInfo?.id]);

    // saques da carteira selecionada (linka invoice.hash = carteira.hash)
    const selectedHw       = hardWallets.find((h) => String(h.id) === selectedHwId);
    const selectedHwSaques = selectedHw ? userInvoices.filter((i) => i.hash && i.hash === selectedHw.hash) : [];
    const totalSacado      = selectedHwSaques.reduce((s, i) => s + Number(i.value || 0), 0);
    const saqueSymbol      = selectedHwSaques[0]?.asset?.symbol;

    return (
        <>
            <div className="wallets-page-wrapper">
                <h1>
                    <div className="round">
                        <Wallet size={20}/>
                    </div>
                    <div className="title-top">
                        Informacoes sobre suas carteiras
                        <small>Gerencie suas wallets conectadas</small>
                    </div>
                </h1>

                {/* Carteiras de destino + saques */}
                <div className="hard-wallets-section">
                    <div className="hw-header">
                        <h3><Wallet2Icon size={18} /> Carteiras cadastradas</h3>
                        <button className="btn-pill primary" onClick={() => setAddWalletOpen(true)}>
                            <Plus size={15} /> Adicionar carteira
                        </button>
                    </div>

                    <div className="hw-select-row">
                        <SelectMenu
                            ariaLabel="Selecione uma carteira"
                            placeholder="Selecione uma carteira"
                            value={selectedHwId}
                            onChange={(v: string) => setSelectedHwId(v)}
                            options={hardWallets.map((hw) => {
                                const label = `${hw.network?.name ? `${hw.network.name} — ` : ""}${hw.hash}`;
                                return { value: String(hw.id), label, text: label };
                            })}
                        />
                        <div className="hw-total">
                            <span>Total já sacado</span>
                            <strong>{formatAssetAmount(String(totalSacado), saqueSymbol)} {saqueSymbol ?? ""}</strong>
                        </div>
                    </div>

                    <div className="hw-saques">
                        {!selectedHwId && <p className="muted">Selecione uma carteira para ver os saques.</p>}
                        {selectedHwId && selectedHwSaques.length === 0 && <p className="muted">Nenhum saque para esta carteira.</p>}
                        {selectedHwId && selectedHwSaques.length > 0 && (
                            <table className="hw-table">
                                <thead>
                                    <tr><th>Valor</th><th>Asset</th><th>Rede</th><th>Status</th><th>Data</th></tr>
                                </thead>
                                <tbody>
                                    {selectedHwSaques.map((s) => (
                                        <tr key={s.id}>
                                            <td>{formatAssetAmount(s.value, s.asset?.symbol)}</td>
                                            <td>{s.asset?.symbol ?? "—"}</td>
                                            <td>{s.network?.name ?? "—"}</td>
                                            <td>{s.status}</td>
                                            <td className="mono">{s.createdAt}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        )}
                    </div>
                </div>
            </div>

            <ModalAddWallet
                open={addWalletOpen}
                onClose={() => setAddWalletOpen(false)}
                userId={userInfo.id}
                onCreated={() => { loadHardWallets(); loadUserInvoices(); }}
            />
        </>
    );
};

export default WalletsPage;
